module.exports = __webpack_public_path__ + "img/1.360ff9e6.png";